import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

import common_store from '@/store/modules/common_store.js';
import common_action from '@/store/modules/common_action.js';
const commonStore = common_store;
commonStore.actions = common_action.actions;

import gmo_store from '@/store/modules/gmo_store.js';
import gmo_action from '@/store/modules/gmo_action.js';
const gmoStore = gmo_store;
gmoStore.actions = gmo_action.actions;

export default new Vuex.Store({
    modules: {
        commonStore,
        gmoStore
    },
    plugins: [createPersistedState({
        storage: window.localStorage,
        paths: ['commonStore']
    })],
});
